import Gateway from '@/utils/Gateway';

export default function getInsteadAppResult() {
    return Gateway.get('/v1/corp/wework/InsteadAppResult', { template: 'address_book' }).then(data => {
        const { status } = data || {};

        return {
            hasInstall: status === 1
        };
    });
}
